import React from 'react';

import {Container, Title, Grid, Row, Col} from './Fraud.style';
import FraudNoticeContent from './FraudNoticeContent';

function FraudAwareness() {
  return (
    <Container>
      <Title>FRAUD AWARENESS</Title>
      <Grid>
        <Row>
          <Col size={1}>
            <FraudNoticeContent />
          </Col>
        </Row>
      </Grid>
    </Container>
  );
}

export default FraudAwareness;
